import { useTranslation } from 'react-i18next'
import { Button, H3, Text, Caption, Span } from '@/components/atoms'
import { FeatureItem } from '@/components/molecules'
import { FEATURE_ICON_CLASS } from '@/shared/constants/icons'
import { useRentersStepFivePage } from './page.onboarding-renters-step-five.hook'

interface RentersStepFivePageProps {
  onContinue: () => void
  onBack: () => void
}

export function RentersStepFivePage({
  onContinue,
  onBack,
}: RentersStepFivePageProps) {
  const { t } = useTranslation()
  const { steps } = useRentersStepFivePage()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:flex md:flex-row md:justify-between md:gap-8 md:pb-0">
        <div className="flex flex-col justify-between gap-4 md:max-w-90">
          <div className="flex flex-col gap-4 md:gap-6">
            <H3 className="text-neutral-900">
              {t('onboarding.renters.stepFive.title')}
            </H3>
            <div className="flex flex-col gap-6">
              <Text className="text-sm text-neutral-900 md:text-base">
                {t('onboarding.renters.stepFive.description')}
              </Text>
              <Caption className="tracking-wide text-neutral-600">
                <Span className={FEATURE_ICON_CLASS}>*</Span>
                {t('onboarding.renters.stepFive.footnote')}
              </Caption>
            </div>
          </div>

          <div className="hidden gap-3 md:flex">
            <Button
              variant="secondary"
              onClick={onBack}
              data-testid="step-five-back"
              className="mb-2.5 h-12"
            >
              {t('onboarding.back')}
            </Button>
            <Button
              onClick={onContinue}
              data-testid="step-five-continue"
              className="mb-2.5 h-12"
            >
              {t('onboarding.continue')}
            </Button>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-4 md:mt-0 md:justify-center md:gap-8">
          {steps.map((step, i) => (
            <FeatureItem
              key={i}
              icon={step.icon}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>

      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          variant="secondary"
          onClick={onBack}
          className="h-12 w-full"
          data-testid="step-five-back"
        >
          {t('onboarding.back')}
        </Button>
        <Button
          onClick={onContinue}
          className="h-12 w-full"
          data-testid="step-five-continue"
        >
          {t('onboarding.continue')}
        </Button>
      </div>
    </div>
  )
}
